<template>
	<div class="c-popup-tags">
		<Popup :active="active" :target="target" @onClose="onClose">
			<!-- <span class="c-popup-tags__reset" v-if="selectedTags.length > 0" @click="onResetTags">
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M5 5L12 12M19 19L12 12M12 12L19 5L5 19" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
				</svg>
				Reset tags</span
			>
			<InputCheckbox v-model="selectedTags" :options="computedTags"></InputCheckbox> -->
			<div class="c-popup-tags__header">
				<InputText placeholder="Search for tags" v-model="query"></InputText>
			</div>

			<div class="c-popup-tags__inner">
				<span
					:class="['c-popup-tags__item', { active: selectedTag === tag.slug }]"
					v-for="(tag, i) in computedTags"
					:key="i"
					@click="toggleSlug(tag.slug)"
				>
					{{ tag.name }}
				</span>
			</div>
		</Popup>
	</div>
</template>

<script>
import Popup from './index';
import InputCheckbox from '@swipekit/components/form/input-checkbox';
import InputText from '@swipekit/components/form/input-text';

import Fuse from 'fuse.js';

export default {
	components: {
		Popup,
		InputCheckbox,
		InputText,
	},

	data: function () {
		return {
			query: '',
			selectedTag: '',
		};
	},

	props: {
		active: {
			type: Boolean,
			default: false,
		},
		target: {},
	},

	watch: {
		selectedTags: function () {
			this.$emit('input', this.selectedTags);
		},
		active: function () {
			if (this.active) {
				let el = this.$el;
				let input = el.querySelector('input');
				if (input) {
					input.focus();
				}
			}
		},
	},

	computed: {
		workspace: function () {
			return this.$store.getters['workspaces/all'];
		},
		computedTags: function () {
			let workspace = this.workspace;

			if (!workspace) {
				return [];
			}

			let tags = workspace.tags2 || [];

			// tags = tags.map((tag) => {
			//   let str = tag;
			//   if (typeof str !== "string") {
			//     str = tag.text;
			//   }
			//   return {
			//     name: str,
			//     slug: str,
			//   };
			// });

			let newTags = [];

			if (this.query) {
				let options = {};
				let fuse = new Fuse(tags, options);
				let items = fuse.search(this.query);
				tags = items.map((i) => {
					return i.item;
				});
			}

			for (let i = 0; i < tags.length; i++) {
				if (typeof tags[i] !== 'string') {
					continue;
				}

				newTags.push({
					name: tags[i],
					slug: tags[i],
				});
			}

			//order them
			newTags.sort(function (a, b) {
				if (a.name < b.name) {
					return -1;
				}
				if (a.name > b.name) {
					return 1;
				}
				return 0;
			});

			return newTags;
		},
	},

	methods: {
		toggleSlug: function (slug) {
			if (!this.selectedTag) {
				this.selectedTag = slug;
				this.$emit('input', slug);
			} else if (this.selectedTag && this.selectedTag !== slug) {
				this.selectedTag = slug;
				this.$emit('input', slug);
			} else {
				this.selectedTag = '';
				this.$emit('input', '');
			}
		},
		onClose: function () {
			this.$emit('onClose');
		},
		onResetTags: function () {
			this.selectedTags = [];
			this.$emit('resetTags');
		},
	},
};
</script>

<style lang="scss">
.c-popup-tags {
	.c-popup {
		width: 300px;
		background-color: var(--color-bg-2);
		box-shadow: inset 0px 0px 0px 1px rgba(255, 255, 255, 0.4),
			inset 0 4px 6px 1px rgba(255, 255, 255, 0.2),
			0 4px 10px 1px rgba(0, 0, 0, 0.2), 0 0 2px 0 rgba(0, 0, 0, 0.05);

		&__arrow {
			color: var(--color-bg-1);
		}
	}
	.c-input-checkbox {
		padding-bottom: 0;
		.c-input-checkbox__item {
			margin-bottom: 0;

			&:not(:last-child) {
				padding-bottom: var(--margin-sm);
			}
		}
	}

	&__header {
		padding: 4px;

		.c-input-text {
			padding-bottom: 0;
			background-color: var(--color-bg-1);
		}
	}

	&__item {
		display: inline-block;
		position: relative;
		margin-right: 4px;
		margin-bottom: 4px;
		background-color: var(--color-bg-4);
		padding: 5.5px 8px;
		padding-right: 14px;
		font-size: var(--font-size-sm);
		font-weight: 500;
		line-height: 1;
		border-radius: var(--border-radius);
		user-select: none;
		cursor: pointer;
		transition: all var(--transition-time-sm) ease-out;

		&:after {
			content: '';
			display: block;
			position: absolute;
			top: calc(50% - 2px);
			right: 6px;
			width: 4px;
			height: 4px;
			background-color: currentColor;
			border-radius: 2px;
		}

		&:hover,
		&:focus,
		&.active {
			outline: none;
			background-color: var(--color-primary);
			color: var(--color-button-font);
		}
	}
	&__inner {
		max-height: 300px;
		overflow-y: auto;
		padding: var(--margin) var(--margin) 0 var(--margin);
	}
	&__close {
		position: absolute;
		top: 12px;
		right: var(--margin-lg);
		opacity: 0.75;
		cursor: pointer;

		&:hover,
		&:active {
			opacity: 1;
		}
	}

	&__reset {
		display: flex;
		padding: var(--margin-lg);
		border-bottom: var(--color-bg-5) solid 1px;
		cursor: pointer;
		user-select: none;

		svg {
			color: var(--color-danger);
			margin-right: var(--margin-sm);
		}
	}
}
</style>
